<clr-modal [(clrModalOpen)]="open" [clrModalClosable]="false">
  <h3 class="modal-title">
    @if (icon) {
      <cds-icon
        style="width: 36px; height: 36px; margin-top: -2px"
        [shape]="icon"
        [ngClass]="iconClass"
        solid="true"></cds-icon>
    }
    {{ options?.title }}
  </h3>

  <div class="modal-body">
    <p style="margin-top: -5px; margin-left: 15px; white-space: pre-line">{{ options?.message }}</p>
  </div>

  <div class="modal-footer">
    @if (options?.showCancel) {
      <button #cancelBtn class="btn btn-outline" (click)="cancel()">
        {{ options?.cancelText }}
      </button>
    }
    <button #okBtn class="btn" [ngClass]="buttonClass" (click)="ok()">
      {{ options?.okText }}
    </button>
  </div>
</clr-modal>
